import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Wrench = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M5.122 21c.378.378.88.586 1.414.586S7.572 21.378 7.95 21l4.336-4.336a7.495 7.495 0 002.217.333 7.446 7.446 0 005.302-2.195 7.484 7.484 0 001.632-8.158l-.57-1.388-4.244 4.243-2.121-2.122 4.243-4.243-1.389-.571A7.478 7.478 0 0014.499 2c-2.003 0-3.886.78-5.301 2.196a7.479 7.479 0 00-1.862 7.518L3 16.05a2.001 2.001 0 000 2.828L5.122 21zm4.548-8.791l-.254-.616a5.486 5.486 0 011.196-5.983 5.46 5.46 0 014.413-1.585l-3.353 3.353 4.949 4.95 3.355-3.355a5.49 5.49 0 01-1.587 4.416c-1.55 1.55-3.964 2.027-5.984 1.196l-.615-.255-5.254 5.256h.001l-.001 1v-1l-2.122-2.122 5.256-5.255z",
    key: "k0"
  }));
});
Wrench.displayName = 'Wrench';
export var WrenchDimensions = {
  height: 24,
  width: 24
};